import { memo } from "react";
import { AxisLeft } from "@visx/axis";
import { format } from "d3";
import type { ScaleLinear } from "d3-scale";
import { chartMargin, AxisGElement } from "./styles";

const formatAsPercentage = ({ value, maxScaleValue }: { value: number; maxScaleValue: number }): string => {
  const valueAsPercentage = value * 100;
  const valueAsPercentageToPrecision: string = valueAsPercentage.toPrecision(2);
  if (Number(valueAsPercentageToPrecision) === 0) {
    return format(".0%")(value);
  } else {
    if (maxScaleValue <= 0.001) {
      if (
        valueAsPercentageToPrecision[valueAsPercentageToPrecision.length - 1] === "0"
      ) {
        if (Number(valueAsPercentageToPrecision) < 0.01) {
          return format(".3%")(value);
        } else {
          return format(".2%")(value);
        }
      } else {
        return format(".3%")(value);
      }
    } else if (maxScaleValue <= 0.01) {
      return format(".2%")(value);
    } else if (maxScaleValue <= 0.1) {
      return format(".1%")(value);
    } else {
      return format(".0%")(value);
    }
  }
};

const YAxisPercentage = ({ scale }: { scale: ScaleLinear<number, number> }) => {
  const maxScaleValue = Math.max(scale.domain()[0], scale.domain()[1]);

  return (
    <AxisGElement transform={`translate(${chartMargin.left}, 0)`}>
      <AxisLeft
        scale={scale}
        numTicks={10}
        tickFormat={(value) => formatAsPercentage({ value: value as number, maxScaleValue })}
        hideAxisLine
        hideTicks
      />
    </AxisGElement>
  );
};

export default memo(YAxisPercentage);
